import { createContext, useRef, useState } from 'react'
import RingoverSDK from 'ringover-sdk'

export const RingoverContext = createContext({
  initRingover: () => {},
  hideRingover: () => {},
  startCall: () => {},
  showRingover: () => {},
})

export const RingoverProvider = ({ children }) => {
  const [openRingoverFrame, setOpenRingoverFrame] = useState(false)
  const ringoverSdk = useRef(null)

  const initRingover = () => {
    if (!ringoverSdk.current) {
      ringoverSdk.current = new RingoverSDK({
        container: 'iframe-ringover',
        trayicon: false,
      })
      ringoverSdk.current.generate()
      ringoverSdk.current.hide()
    }
  }

  const hideRingover = () => {
    if (ringoverSdk.current) {
      ringoverSdk.current.hide()
      setOpenRingoverFrame(false)
    }
  }
  const showRingover = () => {
    if (ringoverSdk.current) {
      ringoverSdk.current.show()
      setOpenRingoverFrame(true)
    }
  }
  const startCall = (number) => {
    showRingover()
    if (ringoverSdk.current) {
      ringoverSdk.current.dial(number)
    }
  }

  return (
    <RingoverContext.Provider
      value={{
        startCall,
        initRingover,
        hideRingover,
        showRingover,
        openRingoverFrame,
      }}
    >
      {children}
    </RingoverContext.Provider>
  )
}
export default RingoverProvider
